import { defineStore } from "pinia";
import axiosInstance from "../config/axios";
export const useShopStore = defineStore("shop", {
    state: () => {
        return {
            cities: [],
            formattedShops: [],
            selectedShop: null,
            selectedShopId: null,
            selectedShopStore: null,
            shop: null,
            shopLocations: [],
            shopStores: [],
            shops: [],
            source: "",
            loadingShopStores: false
        };
    },
    getters: {
        getShops(state) {
            let uniqueCountries = state.formattedShops && state.formattedShops.map((shop) => shop.country_name);
            uniqueCountries = uniqueCountries?.filter(
                (uniqueCountry, index) => uniqueCountries.indexOf(uniqueCountry) === index
            );

            uniqueCountries = uniqueCountries?.map((uniqueCountry) => ({
                country: uniqueCountry,
                items: state.formattedShops.filter((shop) => shop.country_name === uniqueCountry),
            }));

            return uniqueCountries ? uniqueCountries : [];
        },
    },
    actions: {
        fetchShops() {
            return axiosInstance.get("/v1/home/shops").then((response) => {
                this.shops = response.data;
                this.formattedShops = response.data;
            });
        },
        fetchUserShops(userId) {
            return axiosInstance.get(`/v1/home/users/${userId}/shops`).then((response) => {
                this.shops = response.data;
                this.formattedShops = response.data;
            });
        },

        filterFormattedShops(inputText) {
            this.formattedShops = [...this.shops];
            this.formattedShops = this.formattedShops.filter((shop) => shop.name.toLowerCase().includes(inputText.toLowerCase()));
        },
        async fetchShopStores(shopId) {
            return axiosInstance.get(`/v1/home/stores/${shopId}`).then((response) => {
                this.shopStores = response.data;
            });
        },
        async fetchCities(countryId) {
            return axiosInstance.get(`/v1/home/cities/${countryId}`).then((response) => {
                this.cities = response.data;
            });
        },
        async saveShopStore({ shopId, data }) {
            return axiosInstance.post(`/v1/home/store/${shopId}`, data).then((response) => {
                return response;
            });
        },
        async updateShopStore({ id, data }) {
            return axiosInstance.put(`/v1/home/store/${id}`, data).then((response) => {
                return response;
            });
        },
        async deleteShopStore(id) {
            return axiosInstance.delete(`/v1/home/store/${id}`);
        },
    },
});
